export default "__VITE_ASSET__5cc3df99__"